import lowerCase from 'lodash/lowerCase';

import ViewExportContainer from '../ViewExport/ViewExportContainer';

import { formatDate, toSentenceCase } from '../../utils';
import { getFullName, getRoleName } from '../Person/utils';

const getTableData = (data, columns) => {
  const headers = columns.map(({ Header }) => Header);

  const rows = [];
  data.forEach(
    ({
      person,
      role,
      buildingName,
      doors,
      comments,
      source,
      createdAt,
      unitName,
      snapshots,
    }) => {
      let visitorTypeOrUnit = 'Building visitor';
      if (unitName) {
        visitorTypeOrUnit = unitName;
      }

      const row = [
        getFullName(person),
        toSentenceCase(getRoleName(role)),
        buildingName,
        visitorTypeOrUnit,
        doors?.map(({ name }) => name)?.join(', '),
        snapshots?.[0]?.url,
        comments,
        lowerCase(source),
        formatDate(createdAt),
      ];

      rows.push(row);
    },
  );

  return { headers, rows };
};

const VisitorLogTableExport = (props) => (
  <ViewExportContainer {...props} getTableData={getTableData} />
);

export default VisitorLogTableExport;
